<template>
    <mobile-navbar>
        <div slot="main-nav" class="flex justify-between max-height">
            <div class="flex items-center max-height">
                <div v-if="isAuthenticated" @click="toggleMainNav" class="mobile-nav__hamburger flex-center max-height p-l-lg p-r-lg" :class="{ 'theme-bg--charcoal': showMainDropDown }">
                    <i class="fa" :class="{ 'fa-times': showMainDropDown, 'fa-bars': !showMainDropDown }" aria-hidden="true"></i>
                </div>
                <a :href="myAccountUrl" class="mobile-nav__br-logo flex-center max-height p-l-md p-r-md">
                    <logo></logo>
                </a>
            </div>

            <div v-if="showPipes" class="mobile-nav__pipe self-center theme-bg--charcoal"></div>

            <div v-if="showVerticalSelect" @click="toggleVerticalsNav" class="flex-center max-height p-l-md p-r-md" :class="{ 'theme-bg--charcoal': showVerticalsDropdown }">
                <a href="#" class="uppercase">
                    {{ currentVerticalText }}
                    <i class="fa fa-chevron-down mobile-nav__chevron m-l-xs theme-fg--black-light-light" aria-hidden="true"></i>
                </a>
            </div>

            <div v-if="showPipes" class="mobile-nav__pipe self-center theme-bg--charcoal"></div>

            <div v-if="isAuthenticated" @click="toggleUserNav" class="mobile-nav__user-icon flex-center max-height p-l-md p-r-md" :class="{ 'theme-bg--charcoal': showUserDropdown }">
                <user-icon v-if="hasMultipleVerticals"></user-icon>
                <a v-else href="#" class="block p-t-lg p-l-lg p-b-lg">{{ username }} <i class="fa fa-chevron-down navbar__icon theme-fg-gray--dark" aria-hidden="true"></i></a>
            </div>
        </div>

        <div slot="sub-nav" v-if="subMenuItems">
            <a v-for="(item, index) in subMenuItems" :key="index" v-if="!item.hide && item.url" :href="item.url" class="flex items-center justify-between p-l-xl p-r-xl p-t-md p-b-md theme-bg--charcoal uppercase">
                {{ item.label }}
            </a>
        </div>
    </mobile-navbar>
</template>

<script>
import Logo from '../logo'
import MobileNavbar from '../templates/mobile-navbar';

export default {
    components: { Logo, MobileNavbar },

    props: {
        username: String,
        currentVertical: String,
        myAccountUrl: String,
        mainLinks: Array,
        verticalLinks: Array,
        userLinks: Array,
        isAuthenticated: Boolean,
        advertiserId: Number,
        showFavorite: Boolean
    },

    data: () => {
        return {
            showMainDropDown: false,
            showVerticalsDropdown: false,
            showUserDropdown: false,
        }
    },

    computed: {
        subMenuItems() {
            if (this.showMainDropDown) {
                return this.mainLinks;
            }

            if (this.showVerticalsDropdown) {
                return this.verticalLinks;
            }

            if (this.showUserDropdown) {
                return this.userLinks;
            }
        },
        showPipes() {
            return this.isAuthenticated && this.hasMultipleVerticals;
        },
        showVerticalSelect() {
            return this.isAuthenticated && this.hasMultipleVerticals;
        },
        hasMultipleVerticals() {
            return this.verticalLinks.length > 1;
        },
        currentVerticalText() {
            return this.currentVertical ? this.currentVertical : 'Product';
        }
    },

    methods: {
        toggleMainNav() {
            this.showMainDropDown = !this.showMainDropDown;
            this.showVerticalsDropdown = this.showUserDropdown = false;
        },
        toggleVerticalsNav() {
            this.showVerticalsDropdown = !this.showVerticalsDropdown;
            this.showMainDropDown = this.showUserDropdown = false;
        },
        toggleUserNav() {
            this.showUserDropdown = !this.showUserDropdown;
            this.showMainDropDown = this.showVerticalsDropdown = false;
        }
    },
}
</script>
